import { generateUUID } from 'common/utils/utils';

export default function defaultPhoneNumber(isPrimary = false) {
  return {
    id: generateUUID(),
    phone_number: '',
    acceptable_communication_types: {},
    is_primary: isPrimary,
  };
}
